module.exports = __webpack_public_path__ + "img/products-1.c95defa6.jpg";